import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import { CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { useRole } from "components/Hooks/UserHooks";
import { formatDateStringToKorea } from "helpers/format";
import CountUp from "react-countup";
import { getURLWithDomain } from "utils";
import CreateEditAppliedHistory from "./component/CreateEditAppliedHistory";
import noImageCompany from "../../../assets/images/no-company.png";
import noImageAudition from "../../../assets/images/no-image.jpg";
import { COLOR_APPLICATION_STATUS, LIST_OPTION_APPLICATION_STATUS } from "helpers/constans";
import userApi from "api/userApi";

registerLocale("en", en);
registerLocale("ko", ko);

const AppliedHistoryTab = ({data} : {data: any}) => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const [query, setQuery]: any = useState({
    page: 1,
    limit: 30,
    keyword: "",

    sort_by: "created_at",
    order_by: "DESC",
  });

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [userID, setUserID] = useState<string | number>('');
  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [linkImage, setLinkImage] = useState<any>(null);
  const [appliedHistories, setAppliedHistories] = useState<any>([]);

  const [listBar, setListBar] = useState<any>([]);
  const [listGroup, setListGroup] = useState<any>([]);

  const loadTableData = async (queryData?: any) => {
    if(!userID) return;

    setIsLoading(true);
    try {
      const resAuditonApplication: any = await userApi.getAppliedHistoryByUser(userID, queryData);
      console.log(resAuditonApplication)
      if (resAuditonApplication?.data) {
        setAppliedHistories(resAuditonApplication?.data);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error)
    }
  }

  useEffect(() => {
    loadTableData();
  }, [JSON.stringify(query), userID]);

  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 50,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div>
              {appliedHistories?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "status",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "align-middle text-center",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${
                  COLOR_APPLICATION_STATUS[status] || "secondary"
                }`}
              >
                {t(
                  LIST_OPTION_APPLICATION_STATUS?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("photo"),
        accessor: "audition.image_urls",
        thClass: "align-middle text-center",
        filterable: true,
        sortable: false,
        thWidth: 170,
        Cell: (cell: any) => {
          const imageURLS = cell?.value;
          let thumbnailUrl = getURLWithDomain(imageURLS?.[0]);
          return thumbnailUrl ? (
            <>
              <div className="w-100 text-center " style={{ minWidth: "60px" }}>
                <div
                  style={{ width: "48px" }}
                  className="m-auto cursor-pointer"
                  onClick={() => {
                    let linkImage = thumbnailUrl
                      ? { url: thumbnailUrl }
                      : { urls: imageURLS };
                    setLinkImage(linkImage);
                    document.body.className = "modal-open_img";
                  }}
                >
                  <img
                    src={thumbnailUrl}
                    className="flex-shrink-0 rounded w-100"
                    alt="thumbnail"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = noImageAudition;
                    }}
                  />
                </div>
              </div>
            </>
          ) : (
            ""
          );
        },
      },
      {
        Header: t("Audition Title"),
        accessor: "audition.title",
        filterable: true,
        sortable: false,
        thWidth: 200,
        Cell: (cell: any) => {
          const title = cell?.value;
          return (
            <>
              <div className="cursor-pointer" style={{ minWidth: "200px" }}>
                {title}
              </div>
            </>
          );
        },
      },
      {
        Header: t("applyStart"),
        accessor: "audition.application_start_date",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "align-middle text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("applyEnd"),
        accessor: "audition.application_end_date",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "align-middle text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Company Logo"),
        accessor: "company.logo_url",
        thClass: "text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 100,
        Cell: (cell: any) => {
          const imgUrl = cell?.value;
          return imgUrl ? (
            <>
              <div className="w-100 text-center ">
                <div
                  style={{ width: "90px" }}
                  className="m-auto cursor-pointer"
                  onClick={() => {
                    setLinkImage(imgUrl);
                    document.body.className = "modal-open_img";
                  }}
                >
                  <img
                    src={imgUrl ?? noImageCompany}
                    style={{ borderRadius: "10px" }}
                    className="avatar-sm"
                    alt="thumbnail"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = noImageCompany;
                    }}
                  />
                </div>
              </div>
            </>
          ) : (
            ""
          );
        },
      },
      {
        Header: t("Company name"),
        accessor: "company.name",
        thClass: "text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 200,
        Cell: (cell: any) => {
          const name = cell?.value;
          return (
            <>
              <div className="cursor-pointer" >
                {name}
              </div>
            </>
          );
        },
      },
      {
        Header: t("audition_position"),
        accessor: "roles",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return (
            <div className="d-flex flex-wrap align-items-center gap-1">
              {cell?.value?.map((i: any, index: number) => (
                <div
                  key={index}
                  className="d-flex align-items-center gap-1 bg-primary badge rounded-pill"
                >
                  {`${i?.field?.title} - ${i?.field_role_group?.title} - ${i?.audition_role?.title}`}
                </div>
              ))}
            </div>
          );
        },
      },
      {
        Header: t("Submited at"),
        accessor: "audition.created_at",
        filterable: true,
        sortable: true,
        thWidth: 150,
        thClass: "text-end",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end pe-3" style={{ minWidth: "120px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
    ],
    [i18n?.language, appliedHistories?.pagination?.total]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
  }, []);

  useEffect(() => {
    if(data?.id) {
      setUserID(data?.id)
    }
  }, [data])

  useEffect(() => {
    document.title = `${t("Applied History")}| ShowStar`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div>
        <Container fluid>
          <Row>
            <Col lg={12}>
              <div
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={appliedHistories?.pagination?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                {/* <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4 px-0">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-md-2 mt-0">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Name")}
                          isShow={!!keywordSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Name")}...`}
                            value={keywordSearch}
                            onChange={(e) => setKeywordSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={9}
                        xl={9}
                        xxl={9}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-3 mt-md-2"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                            disabled={isAppliedHistoryLoading}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div> */}
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={
                        appliedHistories?.items?.length
                          ? appliedHistories?.items
                          : []
                      }
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={appliedHistories?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(appliedHistories?.pagination?.total) /
                          Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isLoading}
                      defaultScrollBottom={(appliedHistories?.items ?? [])?.length < 5 ? true : false}
                    />
                  </div>
                </CardBody>
              </div>
            </Col>
          </Row>
        </Container>

        {isOpen && (
          <CreateEditAppliedHistory
            setIsOpen={setIsOpen}
            item={itemToEdit}
            setItemToEdit={setItemToEdit}
            loadTableData={loadTableData}
            listBar={listBar}
            listGroup={listGroup}
            linkImage={linkImage}
            setLinkImage={setLinkImage}
            onCloseImageClick={onCloseImageClick}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default AppliedHistoryTab;
